







































































































































import { defineComponent, reactive } from '@vue/composition-api'
import { GetSpecialOfferReceiptResponse } from 'api/@types'
import useVuex from '@/utils/useVuex'
import { UserState } from '@/types/store'
import { UserRole } from '@/types/user'

export const ngReasons: {
  value: GetSpecialOfferReceiptResponse['ngReason']
  text: string
}[] = [
  { value: 'fuzzy_receipt', text: '画像不明瞭' },
  { value: 'invalid_chain_store', text: '対象外チェーン' },
  { value: 'invalid_date_time', text: '対象外購入日時' },
  { value: 'invalid_item', text: '対象外商品' },
  { value: 'invalid_receipt', text: '対象外画像' },
  { value: 'illegal_receipt', text: '不正加工' },
  { value: 'duplicated_receipt', text: '重複レシート' },
  { value: 'other', text: 'その他' },
]

export const statuses: { value: string; text: string }[] = [
  { value: 'admin', text: 'すべて' },
  { value: 'unchecked', text: '未チェック' },
  { value: 'unchecked-ok', text: 'リンカーOK処理残' },
  { value: 'unchecked-ng', text: 'リンカーNG処理残' },
  { value: 'leader-checked', text: 'リーダーOK' },
  { value: 'leader-ng', text: 'リーダーNG' },
]

type Props = {
  total: number
}

export default defineComponent({
  name: 'SpecialOfferSearchInput',
  props: {
    total: {
      type: Number,
      default: 0,
    },
  },
  setup(props: Props, context) {
    const store = context.root.$store
    const state = reactive({
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      id: null,
      transactionId: null,
      importedAtStart: null,
      importedAtEnd: null,
      specialOfferId: null,
      specialOfferNameAdmin: null,
      specialOfferTitle: null,
      ngReason: null,
      status: 'admin',
    })

    const search = () => {
      const query = Object.entries(state)
        .filter(([_key, value]) => value !== null)
        .reduce((prev, [key, value]) => {
          prev[key] = value
          return prev
        }, {} as any)

      context.emit('on-search', query)
    }

    const reset = () => {
      state.id = null
      state.transactionId = null
      state.importedAtStart = null
      state.importedAtEnd = null
      state.specialOfferId = null
      state.specialOfferNameAdmin = null
      state.specialOfferTitle = null
      state.ngReason = null
      state.status = 'admin'

      search()
    }

    const flags = reactive({
      importedAtStartMenu: false,
      importedAtEndMenu: false,
    })

    return {
      state,
      flags,
      props,
      search,
      reset,
      ngReasons,
      statuses,
      UserRole,
    }
  },
})
